export default __webpack_public_path__ + "static/media/Hanley_V_IMG9057.609d349d.jpg";